module.exports = __webpack_public_path__ + "static/media/diktat-21.86e64779.mp3";